/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   useUnmount
 */

import { useEffect } from 'react'

export const useUnmount = (callback?: () => void) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (callback) {
      return () => {
        callback()
      }
    }
    return () => null
  }, [])
}
